import { Typography } from "@mui/material";
import type { ValidationResult } from "@entrilia/shared/utilities/validators";
import { requiredValidator } from "@entrilia/shared/utilities/validators";
import type { EntityFieldComponentProps } from "../entityFieldTypes";
import { removeDecimalNotSupportedCharacters } from "../fieldValuesManagement";
import { formatNumericFieldValue } from "../helpers";
import EntityTextFieldComponent from "./EntityTextFieldComponent";

const EntityNumberComponent = ({
  value,
  onChange,
  fieldId,
  fieldConfiguration,
  fieldAttributes,
  fieldInputId,
}: EntityFieldComponentProps<number>) => {
  const handleChange = (value: string, fieldId: string, validationResult: ValidationResult) => {
    onChange(value ? parseFloat(value) : undefined, fieldId, validationResult);
  };

  const validator = fieldAttributes.includes("Required") ? requiredValidator : undefined;

  const displayValue = formatNumericFieldValue(value, fieldConfiguration);

  return (
    <EntityTextFieldComponent
      value={typeof value === "number" && !Number.isNaN(value) ? value.toString() : ""}
      fieldId={fieldId}
      fieldConfiguration={fieldConfiguration}
      fieldAttributes={fieldAttributes}
      fieldInputId={fieldInputId}
      onChange={handleChange}
      transformOnChangeFunc={removeDecimalNotSupportedCharacters}
      displayValueComponent={displayValue ? <Typography>{displayValue}</Typography> : null}
      validator={validator}
    />
  );
};

export default EntityNumberComponent;
